module.exports = __webpack_public_path__ + "static/media/logo.cdba39f7.svg";